import {
    isLocalStorage,
    getCookie,
    setCookie,
    makeEqual,
    isIncognito,
    setZipFormValidityAlert,
} from './_Utils';

// lightbox
function closeLightbox() {
    $('.overlay').removeClass('active');
    $('.lightbox').removeClass('active');
}

function checkAwesomplete() {
    if (
        $('input[name="brand"]').length > 0 &&
        $('input[name="brand"]').is(':visible') &&
        $('input[name="brand"]').parent('.awesomplete').length === 0
    ) {
        $.ajax({
            dataType: 'json',
            url: '/wp/wp-admin/admin-ajax.php?action=filter_providers',
        }).done((res) => {
            if (res.length > 0) {
                if ($('#brand').length > 0) {
                    // eslint-disable-next-line no-undef
                    new Awesomplete(document.getElementById('brand'), {
                        list: res,
                    });
                    $('#brand').removeAttr('disabled');
                }
                if ($('#brand2').length > 0) {
                    // eslint-disable-next-line no-undef
                    new Awesomplete(document.getElementById('brand2'), {
                        list: res,
                    });
                    $('#brand2').removeAttr('disabled');
                }
            }
        });
    }
}

function openLightbox(e) {
    const box = $(e).data('box');
    const fromTop = $(window).scrollTop();
    // if overlay element doesn't exist, create it
    if ($('.overlay').length === 0) {
        $('body').append('<div class="overlay"></div>');
    }
    $('.lightbox').removeClass('active');
    $(`.lightbox[data-rel="${box}"]`)
        .css('top', fromTop + 60)
        .addClass('active');
    $('.overlay').addClass('active');
    checkAwesomplete();
    if (box === 'ctamqual') {
        // eslint-disable-next-line no-undef
        loadCTAMAutocomplete();
    }
}

function newsletterPopup() {
    if (document.querySelector('[data-rel="newsletter-popup"]')) {
        // Track if popup has been shown
        let popupShown = false;
        // Track user activity
        let idleTime = 0;
        $(document).ready(() => {
            // Increment idle time every second
            setInterval(() => {
                idleTime++;
            }, 1000);

            // Reset idle time on mouse move or key press
            function resetIdleTime() {
                idleTime = 0;
            }

            $(document).mousemove(resetIdleTime);
            window.addEventListener('scroll', resetIdleTime);
            window.addEventListener('wheel', resetIdleTime);
            document.addEventListener('keydown', resetIdleTime);
        });

        // Show popup after 3 seconds idle
        setInterval(() => {
            if (idleTime >= 3 && !popupShown) {
                // Show popup
                $('.overlay').addClass('active');
                const fromTop = $(window).scrollTop();
                $('.lightbox[data-rel="newsletter-popup"]')
                    .css('top', fromTop + 60)
                    .addClass('active');

                popupShown = true;
            }
        }, 1000);
    }
}

// Default initialization routine
const init = () => {
    $(document).foundation();

    checkAwesomplete();

    newsletterPopup();

    const lang = $('html').attr('lang');

    $(window).resize(() => {
        makeEqual();

        if (
            $(window).width() < 640 &&
            !$('.mobile-slider').hasClass('slick-initialized')
        ) {
            $('.mobile-slider').slick({
                slidesToShow: 1,
                arrows: false,
                dots: true,
            });
        } else if (
            $(window).width() >= 640 &&
            $('.mobile-slider').hasClass('slick-initialized')
        ) {
            $('.mobile-slider').slick('unslick');
        }
    });

    makeEqual();

    if ($(window).width() < 640) {
        $('.mobile-slider').slick({
            slidesToShow: 1,
            arrows: false,
            dots: true,
        });
    }

    // affiliate disclaimer iframe
    if (getCookie('noDisclaimer') === 'true') {
        $('.disclaimer-container').remove();
    }

    function hideDisclaimer() {
        $('.disclaimer-container').remove();
        setCookie('noDisclaimer', 'true', '30');
    }

    $('.disclaimer-close').click(() => {
        hideDisclaimer();
    });

    $('.toggle-mobile-nav').on('click', () => {
        $('.site-navigation').toggleClass('active');
        $('.mobile-nav').toggleClass('active');
    });

    // set zip codes in input fields
    if (isLocalStorage() && !isIncognito() && localStorage.getItem('zipCode')) {
        $('.zip-finder').each((i, v) => {
            $(v).find('input[name="zip"]').val(localStorage.getItem('zipCode'));
        });
    }

    // only allow numbers in zip code field
    $('#newsletter-zip, #incontent-newsletter-zip, #newsletter-popup-zip').mask(
        '00000'
    );

    // only allow numbers in zip code field
    $('input[name="zip"][data-type!="address"]')
        .mask('00000')
        .each(function () {
            setZipFormValidityAlert(this);
        });

    $('.lang-nav-container').append(
        '<select class="simple-select lang-nav"></select>'
    );

    $('.lang-nav-container a').each((i, e) => {
        const langLink = e.getAttribute('href');
        const langName = e.text;
        let langSelected = '';
        if (lang === 'es-US' && e.getAttribute('lang') === 'es-US') {
            langSelected = 'selected';
        }
        $('.lang-nav').append(
            `<option value='${langLink}' ${langSelected}>${langName}</option>`
        );
        $('.lang-nav').attr('data-component', 'footer');
        $('.lang-nav').attr('data-component-detailed', 'language dropdown');
    });

    // change page on state select
    $('.state-list, .city-list, .select-nav, .lang-nav').on('change', (e) => {
        window.location.href = `${
            e.currentTarget[e.currentTarget.selectedIndex].value
        }`;
    });

    // lazy load backgrounds, javascript and whistleOut Widget
    document.addEventListener('lazybeforeunveil', (e) => {
        const ajax = $(e.target).data('js'); // lazyload JS
        const bg = $(e.target).data('bg'); // lazyload Backgrounds

        if (ajax) {
            const resource = document.createElement('script');
            resource.async = 'true';
            resource.src = ajax;

            const script = document.getElementsByTagName('script')[0];
            script.parentNode.insertBefore(resource, script);
        }

        if (bg) {
            $(e.target).css({
                'background-image': `url(${bg})`,
            });
        }
    });

    // change zip form
    $(document).on('click', '.change-zip-text', () => {
        $('.change-zip-container').addClass('active');
        $('.change-zip-form input').focus();
    });

    // geo scroller stuff
    $('[data-scroll]').on('click', (e) => {
        e.preventDefault();
        const scrollTo = $(e.currentTarget).data('scroll');
        $('html, body').animate(
            { scrollTop: $(`#${scrollTo}`).offset().top - 100 },
            300
        );
    });

    $('.jump-select').change((e) => {
        window.location.href = `${
            e.currentTarget[e.currentTarget.selectedIndex].value
        }`;
    });

    $('.faq-toggle').click((e) => {
        const q = $(e.currentTarget).parent('div').parent('div');

        q.find('.faq-answer').slideToggle();

        q.find('.faq-status').toggleClass('active');
    });

    // lightbox
    $(document).on('click', '.overlay, .lightbox-close', () => {
        closeLightbox();
    });

    $(document).keyup((e) => {
        if (e.keyCode === 27) {
            // escape key maps to keycode `27`
            closeLightbox();
        }
    });

    $(document).on('click', '[data-box]', (e) => {
        e.preventDefault();
        openLightbox(e.currentTarget);
    });

    // load js when clicking on activate map
    $('.activate-map').click((e) => {
        const js = $(e.currentTarget).data('include');
        $('.geo-map-image, .activate-map').fadeOut();
        $('.geo-map-interactive').show();
        $.getScript(js);
    });

    $('.popup-map').click((e) => {
        const js = $(e.currentTarget).data('include');
        $.getScript(js);
    });

    // contact form
    $('.contact-form').validate({
        ignore: [],
        rules: {
            brand: {
                realBrand: true,
            },
        },
        messages: {
            brand: {
                realBrand: 'Please choose a valid provider',
            },
        },
    });

    // iOS fix because they cache everything like crazy; it's not great but ¯\_(ツ)_/¯
    window.onpageshow = (e) => {
        if (e.persisted) {
            window.location.reload(true);
        }
    };

    // wrap videos with full width wrapper
    $('iframe[src*="youtube.com"]').each((i, e) => {
        $(e).wrap('<div class="video-wrapper"></div>');
    });

    // Are you happy pop on blog posts
    $('.happy.step-1 .button').click((e) => {
        if ($(e.currentTarget).html() === 'Yes') {
            $('.happy.step-1').hide();
            $('.happy.step-2').fadeIn();
        } else {
            $('.happy.step-1').hide();
            $('.happy.step-2-alt').fadeIn();
        }
    });

    $('.happy.step-2 .button').click((e) => {
        if ($(e.currentTarget).html() === 'No') {
            closeLightbox();
        }
        setCookie('noHappy', 'true', '30');
        $('.et_social_mobile').show();
    });

    $('.happy.step-2-alt .button').click(() => {
        // are not happy. Just close the lightbox no matter what they click
        // set cookie to not show it again
        closeLightbox();
        setCookie('noHappy', 'true', '30');
        $('.et_social_mobile').show();
    });

    $('.happy-box .lightbox-close').click(() => {
        setCookie('noHappy', 'true', '30');
        $('.et_social_mobile').show();
    });

    /* eslint-enable */

    if ($('.sticky-js').length > 0) {
        const stickyElem = document.querySelector('.sticky-js');
        const sticky = stickyElem.offsetTop;

        window.onscroll = () => {
            if (window.pageYOffset > sticky) {
                stickyElem.classList.add('active');
            } else {
                stickyElem.classList.remove('active');
            }
        };
    }

    if (
        document.querySelector('[data-box="woqual"]') !== null &&
        document.querySelector('[data-rel="woqual"]') === null
    ) {
        $('body').append(
            '<div class="overlay"></div>\n' +
                '  <div class="lightbox" data-rel="woqual">\n' +
                '<div class="lightbox-x lightbox-close">&times;</div>\n' +
                '</div>'
        );
    }

    // header search
    $(document).on('click', '.search-trigger', () => {
        $('.header-search__container').addClass('active');
        $('.search-trigger').fadeOut(300, () => {
            $('.header-search__container input[name="s"]').focus();
        });
    });

    $(document).on('click', '.header-search__off', () => {
        $('.header-search__container').removeClass('active');
        $('.search-trigger').fadeIn(300);
    });

    // find all of the equal height scripts
    const equalArray = [];
    document.querySelectorAll('[data-equal]').forEach((e) => {
        const equalName = e.dataset.equal;
        if (!equalArray.includes(equalName)) {
            equalArray.push(equalName);
        }
    });

    // loop over all equal height scripts and check for images
    equalArray.forEach((a) => {
        const allEquals = document.querySelectorAll(`[data-equal='${a}'] img`);
        let imagesLoaded = 0;
        allEquals.forEach((image) => {
            image.addEventListener('load', () => {
                imagesLoaded = imagesLoaded + 1;
                if (imagesLoaded === allEquals.length) {
                    // run makeEqual() after all images have loaded
                    makeEqual();
                }
            });
        });
    });

    const featuredArticles = document.querySelectorAll('.featured-article');
    featuredArticles.forEach((article) => {
        const readMoreLink = article.querySelector('.read-more');
        const hrefValue = readMoreLink.getAttribute('href');

        article.addEventListener('click', () => {
            window.location.href = hrefValue;
        });
    });
};

const initPlacesAutocomplete = () => {
    const addressAutocompleteInputs = $(
        'input[name="zip"][data-type="address"]'
    );

    addressAutocompleteInputs.each(function () {
        const inputElement = this;
        const autocomplete = new window.google.maps.places.Autocomplete(
            inputElement
        );

        autocomplete.addListener('place_changed', function () {
            const place = autocomplete.getPlace();
            const addressComponents = place.address_components;
            let zipCode = '';

            for (let i = 0; i < addressComponents.length; i++) {
                const addressType = addressComponents[i].types[0];
                if (
                    addressType === 'postal_code' &&
                    addressComponents[i].short_name.length === 5
                ) {
                    zipCode = addressComponents[i].short_name;
                    break;
                }
            }

            if (zipCode) {
                $(inputElement).attr('data-zip', zipCode);
            }
        });
    });
};

// Export public methods
export { init, initPlacesAutocomplete };
